import React from "react";
import { ButtonPrimaryV2, UI_BODY_SM, SwitchDouble, SwitchSingle } from "oolib";
import {
  StyledColumn,
  StyledDividerMedium,
  StyledTextarea,
  StyledFeedback,
} from "../../styled";
import { SidebarSection } from "../SidebarSection";
import { DescriptionText } from "../DescriptionText";
import { JsonPreview } from "../JsonPreview";
import { List } from "@/components/UI/List";
import styled from "styled-components";

const StyledSwitchContainer = styled.div`
  margin-bottom: 16px;
`;

export const TemplatesColumn = ({
  templateOptions,
  selectedTemplateOptions,
  handleTemplateToggle,
  customTemplateInput,
  handleCustomTemplateInputChange,
  handleAddCustomTemplate,
  customTemplateFeedback,
  annotationSection,
  documentSection,
  unifiedView,
  unifiedFilters,
  totalFilters,
  generatedActiveFilters,
  usePlatformTemplates,
  handleToggleTemplateSource,
  selfManaged,
  setSelfManaged,
  selfManagedOption,
  forceV3,
  setForceV3,
  forceV3Option,
  showConnections,
  setShowConnections,
  connectionsOption,
}) => {
  const templateSourceOptions = [
    { value: false, display: "Sample Templates" },
    { value: true, display: "Platform Templates" }
  ];

  const currentSourceValue = templateSourceOptions.find(
    opt => opt.value === usePlatformTemplates
  );

  return (
    <StyledColumn>
      <SidebarSection
        title="Content templates"
        description="Control template combinations and watch how shared filters consolidate across content types."
      >
        <StyledSwitchContainer>
          <SwitchDouble
            id="template-source-switch"
            value={currentSourceValue}
            options={templateSourceOptions}
            onChange={(id, newValue) => handleToggleTemplateSource(newValue.value)}
          />
        </StyledSwitchContainer>
        <SwitchSingle
          id="self-managed-switch-main"
          option={selfManagedOption}
          value={selfManaged ? selfManagedOption : undefined}
          onChange={(id, nextValue) => setSelfManaged(Boolean(nextValue))}
          layoutStyle="style2"
        />
        <SwitchSingle
        id="connections-switch"
        option={connectionsOption}
        value={showConnections ? connectionsOption : undefined}
        onChange={(id, nextValue) => setShowConnections(Boolean(nextValue))}
        layoutStyle="style2"
      />
        <StyledDividerMedium />
        <List
          id="template-select"
          isMulti
          disableShadow
          options={templateOptions}
          value={selectedTemplateOptions}
          onChange={(id, option) =>
            handleTemplateToggle(
              selectedTemplateOptions.some((v) => v.value === option.value),
              option
            )
          }
        />
      </SidebarSection>

    <SidebarSection
      title="Add custom template"
      description="Paste a template JSON to experiment with new filter configurations."
    >
      <StyledTextarea
        value={customTemplateInput}
        onChange={(event) => handleCustomTemplateInputChange(event.target.value)}
        placeholder='{"kp_content_type": "example", ...}'
      />
      <ButtonPrimaryV2 onClick={handleAddCustomTemplate}>Add template</ButtonPrimaryV2>
      {customTemplateFeedback ? (
        <StyledFeedback $variant={customTemplateFeedback.type}>
          {customTemplateFeedback.message}
        </StyledFeedback>
      ) : null}
    </SidebarSection>

    <SidebarSection
      title="Final filter sections"
      description="Snapshot of the assembled annotation and document filter sections."
    >
      {annotationSection ? (
        <>
          <StyledDividerMedium />
          <UI_BODY_SM semibold>Annotation filters</UI_BODY_SM>
          <JsonPreview data={annotationSection} collapseDepth={2} />
        </>
      ) : null}
      {documentSection ? (
        <>
          <StyledDividerMedium />
          <UI_BODY_SM semibold>Document filters</UI_BODY_SM>
          <JsonPreview data={documentSection} collapseDepth={2} />
        </>
      ) : null}
      {unifiedView ? (
        <>
          <StyledDividerMedium />
          <UI_BODY_SM semibold>Unified filters</UI_BODY_SM>
          <JsonPreview data={unifiedFilters} collapseDepth={1} />
        </>
      ) : null}
       
      {totalFilters === 0 ? <DescriptionText>No filters generated.</DescriptionText> : null}
    </SidebarSection>
    <SidebarSection
      title="Live filter selections"
      description="Payload emitted by the generated filter module as selections change."
    >
      <JsonPreview
        data={generatedActiveFilters.length ? generatedActiveFilters : null}
        collapseDepth={2}
        emptyFallback="No filters selected."
      />
    </SidebarSection>
  </StyledColumn>
  );
};


